import {XauditModel} from '../xaudit.model';

export class PresentationFoldersConfigurationModel extends XauditModel {
  FolderPresentationID: string;
  LOCID: number;
  DisplayName: string;
  DocumnetFolderId: string = '';
  ParentFolderPresentationID: string = '';
}
